// @flow

import CookiesManager from 'ggApp/utils/CookiesManager';
import type { CookiePayload } from './flowTypes/settingsPayload';
import { COOKIE_CONSENT_NAME } from './constants';

const ONE_YEAR_EXPIRATION_TIME_IN_SECONDS = 365 * 24 * 60 * 60;

// Flow types

/**
 * getCookieConsentValue
 * This method loads cookie consent values from cookie
 * @returns {?CookiePayload} cookiePayload
 */
export function getCookieConsentValue(): ?CookiePayload {
    const cookiesManager = new CookiesManager();
    const cookiePayload: ?CookiePayload = cookiesManager.get(COOKIE_CONSENT_NAME);

    return cookiePayload;
}

/**
 * setCookieConsentValue
 * This method sets cookie policy values to the cookie
 * Cookie expiration time is one year
 * @param {CookiePayload} cookiePayload
 */
export function setCookieConsentValue(cookiePayload: CookiePayload): void {
    const cookiesManager = new CookiesManager();
    cookiesManager.set(COOKIE_CONSENT_NAME, cookiePayload, {
        maxAge: ONE_YEAR_EXPIRATION_TIME_IN_SECONDS,
    });
}
